import { useState, useEffect } from 'react';
import styled from 'styled-components';

// Components
import Button from '../../Button/Button';

const Preset = ({
  id,
  name,
  grid_ident,
  is_default,
  column_state,
  filter_state,
  sort_state,
  // preset_type,
  is_active,
  index,
  setDefaultPreset,
  agGridApi,
  onLoad,
  onOpenModal,
}) => {
  const [hiddenText, setHiddenText] = useState("");
  const [pinnedLeftText, setPinnedLeftText] = useState("");
  const [pinnedRightText, setPinnedRightText] = useState("");
  const [filterText, setFilterText] = useState("");
  const [sortText, setSortText] = useState("");
  const [hoverTitle, setHoverTitle] = useState(false);

  useEffect(() => {
    if(agGridApi && column_state && filter_state && sort_state) {
      let hiddenCols = column_state && column_state.filter(col => col.hide === true && !col.colId.includes("_prs")).map((col) => getColName(col.colId));
      let pinnedLeftCols = column_state && column_state.filter(col => col.pinned == 'left').map((col) => getColName(col.colId));
      let pinnedRightCols = column_state && column_state.filter(col => col.pinned == 'right').map((col) => getColName(col.colId));
      let filterCols = filter_state && Object.keys(filter_state).map(key => getColName(key));
      let sortCols = sort_state && sort_state.map(col => getColName(col.colId));

      let hText = "";
      let pLeftText = "";
      let pRightText = "";
      let filterText = "";
      let sortText = "";

      if(hiddenCols.length > 0) {
        hText += 'Hidden ('+hiddenCols.length+'): ' + hiddenCols.join(', ');
      }
      if(pinnedLeftCols.length > 0) {
        pLeftText += 'Pinned Left ('+pinnedLeftCols.length+'): ' + pinnedLeftCols.join(', ');
      }
      if(pinnedRightCols.length > 0) {
        pRightText += 'Pinned Right ('+pinnedRightCols.length+'): ' + pinnedRightCols.join(', ');
      }
      if(filterCols.length > 0) {
        filterText += 'Filters ('+filterCols.length+'): ' + filterCols.join(', ');
      }
      if(sortCols.length > 0) {
        sortText += 'Sorts ('+sortCols.length+'): ' + sortCols.join(', ');
      }

      setHiddenText(hText);
      setPinnedLeftText(pLeftText);
      setPinnedRightText(pRightText);
      setFilterText(filterText);
      setSortText(sortText);
    }
  }, [agGridApi, column_state, filter_state, sort_state]);

  const onSetDefault = () => {
    setDefaultPreset(index);
  }

  const getColName = (colId) => {
    let header = agGridApi.getColumnDef(colId);
    if(header && header.headerName) return header.headerName;
    return colId;
  }

  return (
    <Container isActive={is_active}>
      <TitleContainer onMouseEnter={() => setHoverTitle(true)} onMouseLeave={() => setHoverTitle(false)}>
        <Title>{name} {is_default && "(default)"}</Title>
        {hoverTitle && <Icon className="fal fa-pencil-alt" onClick={() => onOpenModal("update-preset", {id, name, column_state, filter_state, sort_state, grid_ident, is_default, is_active})}/>}
      </TitleContainer>
      <ConfigContainer>
        <Text>{hiddenText}</Text>
        <Text>{pinnedLeftText}</Text>
        <Text>{pinnedRightText}</Text>
        <Text>{filterText}</Text>
        <Text>{sortText}</Text>
      </ConfigContainer>
      {/* {preset_type === "client" &&  !is_active &&
        <ActionContainer>
          <Button 
            variant="link"
            onClick={() => onLoad({ column_state, filter_state, sort_state })}>
            Load
          </Button>
        </ActionContainer>
      } */}
      {/* {preset_type === "user" && */}
        <ActionContainer>
          {!is_default && 
            <Button 
              variant="link"
              onClick={() => onSetDefault()}>
              Set as Default
            </Button>
          }
          {!is_active &&
            <Button 
              style={{ marginLeft: 20 }}
              variant="link"
              onClick={() => onLoad({ column_state, filter_state, sort_state })}>
              Load
            </Button>
          }
          <Button 
            style={{ marginLeft: 20 }}
            variant="link"
            onClick={() => onOpenModal("delete-preset", { id, name })}>
            <i className="fal fa-trash-alt"></i>
          </Button>
        </ActionContainer>
      {/* } */}
    </Container>
  );
};

export default Preset;

const getBackgroundColor = (isActive) => {
  if(isActive) return "#e0e0e0"
  return "transparent";
}

const getBorderLeft = (isActive) => {
  if(isActive) return "4px solid #1F68F2";
  return "none";
}

const Container = styled.div`
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom: .5px solid #eceff3;
  border-left: ${props => getBorderLeft(props.isActive)};
  background-color: ${props => getBackgroundColor(props.isActive)};
  transition: all .15s;
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  
`

const Title = styled.div`
  font-weight: bold;
`

const Icon = styled.div`
  color: #1F68F2;
  margin-left: 10px;
  cursor: pointer;
`

const Text = styled.div`
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  margin: 0;
  padding: 0;
`

const ConfigContainer = styled.div`
  margin-top: 2px;
`

const ActionContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
`